import type { Dispatch } from 'redux';
import { createActionFactoryForFeature, Feature } from '../../shared';

const actionFactory = createActionFactoryForFeature(Feature.UnifiedGroups);
export const addGroupMembersClickedAction = actionFactory<{
    groupKind: number;
}>('AddGroupMembersClickedAction');

export const addGroupMembersCompletedAction = actionFactory<{
    groupId: string;
    groupSmtp: string;
    hubPersonaId: string;
}>('AddGroupMembersCompletedAction');

export const dismissAddGroupMembersDialogAction = actionFactory<{}>(
    'DismissAddGroupMembersDialogAction'
);

export const addGroupMembersClicked = (dispatch: Dispatch) => (
    groupKind: number,
    addMembersForFamilyUrl: string
) => {
    dispatch(addGroupMembersClickedAction({ groupKind }));
    if (groupKind == 3) {
        window.open(addMembersForFamilyUrl);
    }
};

export const addMembersToGroupCompleted = (dispatch: Dispatch) => (
    groupId: string,
    groupSmtp: string,
    hubPersonaId: string
) => {
    dispatch(
        addGroupMembersCompletedAction({
            groupId,
            groupSmtp,
            hubPersonaId,
        })
    );
};

export const dismissAddMembersDialog = (dispatch: Dispatch): void => {
    dispatch(dismissAddGroupMembersDialogAction());
};
export type { Action } from '../../shared';
